import '../dist/appointment-scheduler-v1.css'
import '../blueprints/appointment-scheduler-v1.ts'
